import { create } from "zustand";
import { nanoid } from "nanoid";
import { useInvoices } from "../../useInvoices";
import { showToast } from "Components/Toast";
import api from "../../../../../api";
import { parsePrice } from "../../../../../helperFunctions";

export let useAccountCodeBlock = create((set, get) => ({
  accountHandler: (value, rowIndex) => {
    const currentState = useInvoices.getState();
    //const updatedCodes = currentState.form.invoice_codes;
    const updatedCodes = currentState.form.invoice_codes.map((row) => [...row]);
    updatedCodes[rowIndex][0] = value;
    if (updatedCodes[rowIndex][1] == "0.00") {
      updatedCodes[rowIndex][1] = parsePrice(
        currentState.form.invoice_total
      ).toFixed(2);
      //console.log('test')
    }

    useInvoices.setState({
      form: {
        ...currentState.form,
        invoice_codes: updatedCodes,
      },
    });
  },

  itemHandler: (value, rowIndex) => {
    const currentState = useInvoices.getState();
    const updatedCodes = currentState.form.invoice_codes.map((row) => [...row]);
    updatedCodes[rowIndex][1] = value;

    useInvoices.setState({
      form: {
        ...currentState.form,
        invoice_codes: updatedCodes,
        total_by_accounts: calcTotalAccounts(updatedCodes),
      },
    });
  },

  addItem: () => {
    const currentState = useInvoices.getState();
    //const newCode= currentState.form.invoice_codes.map(() => ''); // Match the length of itemsTitles
    useInvoices.setState((state) => ({
      form: {
        ...state.form,
        invoice_codes: [...state.form.invoice_codes, ["", ""]],
      },
    }));
  },

  deleteAccount: (rowIndex) => {
    useInvoices.setState((state) => {
      const updatedCodes = state.form.invoice_codes.filter(
        (_, index) => index !== rowIndex
      );
      return {
        form: {
          ...state.form,
          invoice_codes: updatedCodes,
          total_by_accounts: calcTotalAccounts(updatedCodes),
        },
      };
    });
  },
}));

const calcTotalAccounts = (updatedCodes) => {
  const total = updatedCodes.reduce(
    (total, row) => total + parseFloat(row[1]),
    0
  );
  const total_by_accounts = isNaN(total.toFixed(2)) ? "0.00" : total.toFixed(2);
  return total_by_accounts;
};
